import type { UserRecord } from '@libs/data-access/entities'
import { appQueryClient, userService } from '@libs/data-access/queries'
import { cookiesService } from '@libs/utils/cookies'
import type { ReduxState } from '@spa/redux/ReduxState'
import { getRoleRights } from 'snap-redux/modules/memberships/utils'

import { getCurrentMembershipSelector } from '../memberships/selectors'

import { User } from '.'

export const getCurrentUserId = (): number =>
  Number(cookiesService.readUserId())

export const getCurrentUser = (): UserRecord | null => {
  const currentUserId = getCurrentUserId()
  const data = appQueryClient.getQueryData(userService.user.userQueryKeys.me())

  if (!currentUserId || !data) {
    return null
  }

  return new User(data) as unknown as UserRecord
}

export const getCurrentUserRoleRights = state => {
  const currentMembership = getCurrentMembershipSelector(state)
  return getRoleRights(currentMembership)
}

export const getUserById = (state: ReduxState, userId: number): UserRecord =>
  state.users.getIn(['data', Number(userId)])
